import { useState } from 'react';
import { useTelegram } from '../../context/TelegramContext';
import { formatDateTime } from '../../utils/format';
import { GiftsPayload } from '../../types/gifts';

interface VividProfileHeaderProps {
    payload: GiftsPayload;
}

const initialsOf = (first?: string, last?: string): string => {
    const a = (first || '').trim();
    const b = (last || '').trim();
    const initials = `${a.charAt(0)}${b.charAt(0)}`.trim();

    return (initials || a.charAt(0) || '?').toUpperCase();
};

const VividProfileHeader = ({ payload }: VividProfileHeaderProps) => {
    const { user } = useTelegram();
    // `photo_url` is missing on older clients; a failed load falls back to the same initials disc.
    const [imageFailed, setImageFailed] = useState(false);

    const name = [user?.first_name, user?.last_name].filter(Boolean).join(' ') || 'Foydalanuvchi';
    const showImage = Boolean(user?.photo_url) && !imageFailed;

    return (
        <div className="vivid-header">
            <div className="vivid-avatar">
                {showImage ? (
                    <img
                        className="vivid-avatar__img"
                        src={user!.photo_url}
                        alt={name}
                        onError={() => setImageFailed(true)}
                    />
                ) : (
                    <span className="vivid-avatar__initials">{initialsOf(user?.first_name, user?.last_name)}</span>
                )}
            </div>
            <div className="vivid-header__info">
                <div className="vivid-header__name">{name}</div>
                {payload.tariff_title && <span className="vivid-badge">{payload.tariff_title}</span>}
                {payload.end_time && (
                    <div className="vivid-header__until">Faol: {formatDateTime(payload.end_time)} gacha</div>
                )}
            </div>
        </div>
    );
};

export default VividProfileHeader;
